import React, { FC, useEffect, useState } from 'react';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
import './Header.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IntlShape } from 'react-intl';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import { Link } from 'gatsby-plugin-intl';
import { useKeycloak } from '@react-keycloak/web';
import { AuthConstants } from '../../../utils/constants/AuthConstants';
import { Msg } from '../../../utils/helpers/MsgHelper';
import BrowserHelper from '../../../utils/helpers/BrowserHelper';

interface HeaderProfileProps {
  intl: IntlShape;
  logoutHandler: Function;
}

const HeaderProfile: FC<HeaderProfileProps> = (props: HeaderProfileProps) => {
  const { intl, logoutHandler } = props;
  const { keycloak } = useKeycloak();
  const firstName = BrowserHelper.getSessionStorageItem(AuthConstants.USER_DATA_FIRSTNAME);
  const lastName = BrowserHelper.getSessionStorageItem(AuthConstants.USER_DATA_LASTNAME);
  const fullName = `${firstName} ${lastName}` || '';
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const [formatDate, setFormatDate] = useState(moment(new Date()).format('h:mm A ddd, DD MMM, YYYY'));

  const tick = (): void => {
    const newDate = moment(new Date()).format('h:mm A ddd, DD MMM, YYYY');
    setFormatDate(newDate);
  };
  useEffect(() => {
    const time = setInterval(() => tick(), 1000);
    return () => {
      clearInterval(time);
    };
  });

  const handleUpdateIsOpen = (openState: boolean): void => {
    setIsOpen(openState);
  };

  if (keycloak.authenticated) {
    return (
      <UncontrolledDropdown
        onMouseOver={() => handleUpdateIsOpen(true)}
        onFocus={() => handleUpdateIsOpen(true)}
        onMouseLeave={() => handleUpdateIsOpen(false)}
        onBlur={() => handleUpdateIsOpen(false)}
        toggle={() => handleUpdateIsOpen(!isOpen)}
        isOpen={isOpen}
      >
        <DropdownToggle caret className='pb-0'>
          {fullName}
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem className='mt-0' onClick={() => logoutHandler()}>
            <FontAwesomeIcon icon={faSignOutAlt} />
            {Msg(intl, 'navigationMenu.mainMenuHeader.link.logout')}
          </DropdownItem>
        </DropdownMenu>
        <div className='header-date'>{formatDate}</div>
      </UncontrolledDropdown>
    );
  }
  return (
    <Link to='/login'>
      <span>{Msg(intl, 'navigationMenu.mainMenuHeader.link.login')}</span>
    </Link>
  );
};

export default HeaderProfile;
